import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
} from "reactstrap";
import React, { useState } from "react";
import { NavLink, useLocation, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

export const SubjectTabMenu: React.FC = () => {
  const { t } = useTranslation();
  const { url } = useRouteMatch();
  const { search } = useLocation();
  const [aiDropdownOpen, setAiDropdownOpen] = useState(false);

  const toggle = () => setAiDropdownOpen(!aiDropdownOpen);

  const navLinkClass = (isActive: boolean) =>
    classnames("nav-link", { active: isActive });

  return (
    <Nav pills className="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1 flex-wrap mb-0">
      <NavItem>
        <NavLink to={`${url}/organizing${search}`} className={navLinkClass}>
          <i className="ri-book-line d-inline-block d-md-none"></i>
          <span className="d-none d-md-inline-block">{t("organizing")}</span>
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink to={`${url}/questions${search}`} className={navLinkClass}>
          <i className="ri-book-line d-inline-block d-md-none"></i>
          <span className="d-none d-md-inline-block">{t("questions")}</span>
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink to={`${url}/notes${search}`} className={navLinkClass}>
          <i className="ri-file-edit-line d-inline-block d-md-none"></i>
          <span className="d-none d-md-inline-block">{t("notes")}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink to={`${url}/flash-cards-v2${search}`} className={navLinkClass}>
          <i className="ri-slideshow-4-line d-inline-block d-md-none"></i>
          <span className="d-none d-md-inline-block">{t("flashCards")}</span>
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink to={`${url}/lectures${search}`} className={navLinkClass}>
          <i className="ri-slideshow-4-line d-inline-block d-md-none"></i>
          <span className="d-none d-md-inline-block">{t("lectures")}</span>
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink to={`${url}/live-lectures${search}`} className={navLinkClass}>
          <i className="ri-live-line d-inline-block d-md-none"></i>
          <span className="d-none d-md-inline-block">{t("liveLectures")}</span>
        </NavLink>
      </NavItem>

      <Dropdown nav isOpen={aiDropdownOpen} toggle={toggle}>
        <DropdownToggle nav caret>
          {t("ai")}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>{t("ai")}</DropdownItem>

          <DropdownItem tag={NavLink} to={`${url}/documents${search}`}>
            {t("documents")}
          </DropdownItem>

          <DropdownItem tag={NavLink} to={`${url}/instructions${search}`}>
            {t("instructions")}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Nav>
  );
};
